import { DataObject } from "@/types/responses"

export interface Category {
    name: string
    value: string
    color?: string
}

export interface CategoryInfo extends Category {
    isActive: boolean
    deviceCount: number
    power: DataObject | null
    energy: DataObject | null
}

export const CATEGORIES: Category[] = [
    { name: "Grid", value: "GRID", color: "orange" },
    { name: "Solar", value: "SOLAR_POWER_PLANT", color: "yellow" },
    { name: "EV charger", value: "EV_CHARGER", color: "blue" },
    { name: "Battery storage", value: "BATTERY", color: "orange" },
    { name: "Hybrid Inverter", value: "HYBRID_INVERTER", color: "orange" },
    { name: "HVAC", value: "HVAC", color: "purple" },
    { name: "Other", value: "OTHER", color: "green" },
]

export const CATEGORY_ENUMERATIONS = {
    EV_CHARGER: "EV_CHARGER",
    GRID: "GRID",
    OTHER: "OTHER",
    SOLAR_POWER_PLANT: "SOLAR_POWER_PLANT",
    HVAC: "HVAC",
    BATTERY: "BATTERY",
    HYBRID_INVERTER: "HYBRID_INVERTER",
}

export const DATA_CATEGORIES: CategoryInfo[] = CATEGORIES.map((category: Category) => {
    return {
        ...category,
        deviceCount: 0,
        isActive: false,
        power: null,
        energy: null,
    }
})
